/**
 * Theme preference: system (follow the OS), light, or dark.
 *
 * Stored in localStorage so it applies instantly on load with no backend round
 * trip and follows the browser, not the account. "system" removes the
 * data-theme attribute and lets the prefers-color-scheme media query decide;
 * an explicit choice stamps data-theme on <html>, which the CSS overrides key
 * off (see styles.css).
 */

export type ThemePref = "system" | "light" | "dark";

const KEY = "arturo-theme";

export function getThemePref(): ThemePref {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" ? v : "system";
}

export function applyTheme(pref: ThemePref): void {
  const root = document.documentElement;
  if (pref === "system") {
    root.removeAttribute("data-theme");
    localStorage.removeItem(KEY);
  } else {
    root.setAttribute("data-theme", pref);
    localStorage.setItem(KEY, pref);
  }
}

/** Call once at boot, before first paint, to avoid a flash of the wrong theme. */
export function initTheme(): void {
  applyTheme(getThemePref());
}
